var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodaMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_839_7386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#A1E430",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 3.25,
    width: 20.5,
    height: 20.5,
    rx: 10.25,
    stroke: "#A1E430",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_7386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.695 11.4688H20.1748L19.7523 10.4125C19.3182 9.32654 18.282 8.625 17.1122 8.625H13.8876C12.7181 8.625 11.6817 9.32654 11.2472 10.4125L10.8247 11.4688H9.30485C9.10655 11.4688 8.96106 11.6551 9.0093 11.8473L9.16165 12.4567C9.19542 12.5923 9.31729 12.6875 9.45719 12.6875H9.96678C9.62579 12.9853 9.40616 13.4182 9.40616 13.9062V15.125C9.40616 15.5343 9.56256 15.9037 9.81241 16.1896V17.5625C9.81241 18.0112 10.1763 18.375 10.6249 18.375H11.4374C11.8861 18.375 12.2499 18.0112 12.2499 17.5625V16.75H18.7499V17.5625C18.7499 18.0112 19.1138 18.375 19.5624 18.375H20.3749C20.8236 18.375 21.1874 18.0112 21.1874 17.5625V16.1896C21.4373 15.904 21.5937 15.5346 21.5937 15.125V13.9062C21.5937 13.4182 21.374 12.9853 21.0333 12.6875H21.5429C21.6828 12.6875 21.8047 12.5923 21.8384 12.4567L21.9908 11.8473C22.0388 11.6551 21.8933 11.4688 21.695 11.4688ZM12.7559 11.016C12.941 10.5534 13.3892 10.25 13.8876 10.25H17.1122C17.6106 10.25 18.0588 10.5534 18.2439 11.016L18.7499 12.2812H12.2499L12.7559 11.016ZM11.4374 15.1199C10.9499 15.1199 10.6249 14.7959 10.6249 14.31C10.6249 13.824 10.9499 13.5 11.4374 13.5C11.9249 13.5 12.6562 14.229 12.6562 14.7149C12.6562 15.2009 11.9249 15.1199 11.4374 15.1199ZM19.5624 15.1199C19.0749 15.1199 18.3437 15.2009 18.3437 14.7149C18.3437 14.229 19.0749 13.5 19.5624 13.5C20.0499 13.5 20.3749 13.824 20.3749 14.31C20.3749 14.7959 20.0499 15.1199 19.5624 15.1199Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_839_7386",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0 0.6 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_7386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_7386",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.874597 0 0 0 0 0.932332 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_839_7386"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_839_7386",
    result: "effect3_innerShadow_839_7386"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.545098 0 0 0 0 0.772549 0 0 0 0 0.6 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_839_7386",
    result: "effect4_innerShadow_839_7386"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_7386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodaMedia);
export default __webpack_public_path__ + "static/media/coda_media.d6451a25865ba5c220cb431292221a6a.svg";
export { ForwardRef as ReactComponent };